import React from 'react';
import { SkeletonLayout, SkeletonType } from './SkeletonLayout';
import { Box, Stack } from '@mui/material';

export const ContentLayout = ({
    info,
    tabs,
    documentSelection,
    main,
    loading,
}: {
    info?: JSX.Element;
    tabs?: JSX.Element;
    documentSelection?: JSX.Element;
    main?: JSX.Element;
    loading?: boolean;
}) => {
    return (
        <Stack
            sx={{
                width: '512px',
            }}
        >
            {info && (
                <SkeletonLayout loading={loading} type={SkeletonType.Info}>
                    {info}
                </SkeletonLayout>
            )}
            {tabs && (
                <SkeletonLayout loading={loading} type={SkeletonType.Tabs}>
                    {tabs}
                </SkeletonLayout>
            )}
            {documentSelection && (
                <SkeletonLayout loading={loading} type={SkeletonType.DocumentSelection}>
                    <Box sx={{ mb: 2 }}>{documentSelection}</Box>
                </SkeletonLayout>
            )}
            {main && (
                <SkeletonLayout loading={loading} type={SkeletonType.Main}>
                    {main}
                </SkeletonLayout>
            )}
        </Stack>
    );
};
